import React from 'react';
import { EarthMapWidget } from '../EarthMapWidget/index';
import { MapProvider } from '../../contexts/mapContext';

export function EarthMapWrapper({ data, widgetConfiguration, endpointQuery }) {
	return (
		<MapProvider>
			<EarthMapWidget data={data} widgetConfiguration={widgetConfiguration ?? {}} endpointQuery={endpointQuery} />
		</MapProvider>
	);
}
